import { ApiKey } from "./Constants/Constants"
export const originals=`/trending/all/week?api_key=${ApiKey}&language=en-US`
export const action=`/discover/movie?api_key=${ApiKey}&with_genres=28` 
export const ComedyMovies=`/discover/movie?api_key=${ApiKey}&with_genres=35`
export const HorrorMovies=`/discover/movie?api_key=${ApiKey}&with_genres=27`
export const RomanceMovies=`/discover/movie?api_key=${ApiKey}&with_genres=10749`
export const Documentaries=`/discover/movie?api_key=${ApiKey}&with_genres=99`